<template lang="html">
    <div>
        <div class="form-group d-flex">

            <div class="col-sm-12">
                <label>Name<span class="color-6">*</span></label>
                <div class="d-flex align-items-center">
                    <input type="text" class="w-50" v-model="customBusinessType.name" placeholder="name here" />
                </div>
				<div class="mt-2">
					<label>Description</label>
					<div class="d-flex align-items-center">
						<textarea class="w-100" v-model="customBusinessType.description" placeholder="description here"></textarea>
					</div>
				</div>
            </div>

        </div>
    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import { mapActions, mapGetters} from 'vuex'

export default {
    props:{
		customBusinessType:{
            type: Object
        },
    },
	watch:{
		'customBusinessType': {
			handler: function(n, o) {
				if(n && n.name.length > 0){
					this.$emit('canSaveCustomBusinessType', true)
				} else {
					this.$emit('canSaveCustomBusinessType', false)
				}
			},
			deep: true,
		}
	},
    computed:{
        ...mapGetters([
			'getCustomBusinessType',
        ]),
    },
    methods: {
        ...mapActions([
            'closeModal',
        ]),
    },
    components:{
        vSelect: extendedVSelect
    }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// customBusinessTypeForm.vue?69570e47